export const getLegacyEditMenuLabel = (editMode: boolean) => (
  editMode ? 'Desactivar Modo Edicion' : 'Activar Modo Edicion'
);
